import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import Layout from './Layout';

export default function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();

  return auth.user ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to='/login' state={{ from: location }} replace />
  );
}
